import type { UserProfile } from '../../lib/api';

/** Columns, in the same order the Users Management table shows them. */
const HEADERS = [
  'Name', 'Email', 'Company', 'Primary Contact For', 'User Role', 'Status',
  'Approved', 'Last Login', 'Created At',
];

function toRow(u: UserProfile): string[] {
  return [
    u.user.full_name,
    u.user.email,
    u.company_name,
    // Semicolon-separated: the cell quoting below doesn't escape embedded
    // quotes, so keep the payload simple rather than lean on it.
    (u.primary_contact_for ?? []).map((a) => a.company_name).join('; '),
    u.role_name,
    u.user.is_active ? 'Active' : 'Inactive',
    u.is_approved ? 'Yes' : 'No',
    u.user.last_login ? new Date(u.user.last_login).toISOString() : '',
    new Date(u.created_at).toLocaleDateString(),
  ];
}

/**
 * Download the given users as a CSV file.
 *
 * Exports exactly what the table is showing — the caller passes the filtered,
 * sorted list, not the raw fetch.
 *
 * @param users - Users to export, already filtered and sorted for display.
 * @param today - ISO date used in the filename, defaults to now.
 */
export function exportUsersToCSV(users: UserProfile[], today = new Date()): void {
  const rows = users.map(toRow);
  const csv = [
    HEADERS.join(','),
    ...rows.map((r) => r.map((c) => `"${c}"`).join(',')),
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `users-export-${today.toISOString().split('T')[0]}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
